import { Autoplay, Keyboard, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import MainSlide from "./MainSlide";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SenseProfileSlide from "./SenseProfileSlide";
import SpeechllectSlide from "./SpeechllectSlide";

const swiperData = [
  {
    img: "page.main.slider.0.img",
    backgroundPosition: "right / contain",
    firsttitle: "page.main.slider.0.firsttitle",
    secondtitle: "page.main.slider.0.secondtitle",
    linktitle: "page.main.slider.0.linktitle",
    link: "",
    component: <MainSlide />,
  },
  {
    img: "page.main.slider.1.img",
    backgroundPosition: "left / cover",
    firsttitle: "page.main.slider.1.firsttitle",
    secondtitle: "page.main.slider.1.secondtitle",
    linktitle: "page.main.slider.1.linktitle",
    link: "/sense-profile",
    component: <SenseProfileSlide />,
  },
  {
    img: "page.main.slider.2.img",
    backgroundPosition: "center / cover",
    firsttitle: "page.main.slider.2.firsttitle",
    secondtitle: "page.main.slider.2.secondtitle",
    linktitle: "page.main.slider.2.linktitle",
    link: "/speechintellect",
    component: <SpeechllectSlide />,
  },
];

const HomeSlider = () => {
  const { t } = useTranslation();

  return (
    <>
      <Swiper
        style={{ cursor: `url(/assets/img/webp/icon-move-light.webp)` }}
        modules={[Pagination, Keyboard, Autoplay]}
        slidesPerView={1}
        keyboard={{ enabled: true, onlyInViewport: true }}
        pagination={{ clickable: true }}
        direction="horizontal"
        breakpoints={{ 991: { direction: "vertical" } }}
        className="full-screen swiper-pagination-01 swiper-pagination-light swiper-pagination-medium landscape:md:h-[600px] vertical-white-move"
      >
        {swiperData.map((item, i) => {
          return (
            <SwiperSlide
              key={0}
              className="bg-no-repeat bg-cover relative overflow-hidden bg-center"
              style={{
                background: `${item.backgroundPosition} no-repeat url(${t(
                  item.img
                )}), black`,
              }}
            >
              <div className="flex flex-col justify-center h-full lg:mr-[50px] align-start p-[79px] md:p-[29px] xs:p-[15px] xs:mr-[4px] relative">
                {item.component}

                {!!item.link && (
                  <Link
                    aria-label={t(item.linktitle)}
                    to={item.link}
                    className="left-[89px] bottom-[100px] z-[100] absolute md:bottom-[50px] sm:bottom-[60px]  sm:left-[30px]"
                  >
                    <span className="flex items-center text-center hover:text-[#828282]">
                      <span className="w-[50px] h-[50px] text-lg relative flex justify-center items-center rounded-[50%] mr-[25px] border-[2px] border-[#cc754c4d]">
                        <i className="fas fa-arrow-right text-basecolor flex items-center justify-center text-xmd leading-normal ml-0"></i>
                      </span>
                      <span className="text-white font-medium text-xmd font-serif uppercase inline-block align-middle">
                        {t(item.linktitle)}
                      </span>
                    </span>
                  </Link>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default HomeSlider;
